import type { SkuBenchmark } from '../../data/analytics';
import { hasBenchmarkPopulation } from '../../lib/benchmarks';
import { fmtMs, pctFine } from '../../lib/format';

export interface EndpointHealthProps {
  benchmark?: SkuBenchmark;
}

/** One endpoint's current-window uptime and p50. The call sample behind each
 *  figure is disclosed on the endpoint detail page, not here: in a list every
 *  row repeats it twice and it wraps the column. `hasBenchmarkPopulation` still
 *  suppresses a figure whose population is too thin to publish. */
export const EndpointHealth = ({ benchmark }: EndpointHealthProps) => {
  if (!benchmark) {
    return <span className="mono text-15 text-text-3">-</span>;
  }
  const showUptime = hasBenchmarkPopulation(benchmark.uptimeSample);
  const showLatency = hasBenchmarkPopulation(benchmark.latencySample);
  if (!showUptime && !showLatency) {
    return <span className="mono text-15 text-text-3">-</span>;
  }
  return (
    <>
      <div className="mono flex items-center gap-1.5 text-15 text-text">
        {showUptime ? (
          <>
            <span className="size-1.5 rounded-full bg-pos" />
            {pctFine(benchmark.uptimePct)}
          </>
        ) : '-'}
      </div>
      <div className="mono mt-1 text-11 text-text-3">
        {showLatency ? `${fmtMs(benchmark.latencyP50Ms)} p50` : '-'}
      </div>
    </>
  );
};
